var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.filters
    ? _c("div", { staticClass: "products__categories-item" }, [
        _c(
          "a",
          {
            staticClass:
              "products__categories-item-link products-filter__trigger",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleOverlay.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "products__categories-item-inner" },
              [
                _vm.filtersActive.length
                  ? _c("span", {
                      staticClass: "products__categories-item-badge",
                      domProps: { innerHTML: _vm._s(_vm.filtersActive.length) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("SVGFilter", {
                  staticClass: "products__categories-item-icon",
                }),
                _vm._v(" "),
                _c("span", {
                  staticClass: "products__categories-item-text",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("shoplist.filter.iconLabel")),
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "products-filter" }, [
          _c(
            "div",
            { staticClass: "products-filter__wrapper" },
            [
              _c("div", { staticClass: "products-filter__header" }, [
                _c("h3", {
                  staticClass: "products-filter__title",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("shoplist.filter.title")),
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "products-filter__close",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.closeOverlay.apply(null, arguments)
                      },
                    },
                  },
                  [_c("SVGClose")],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.filtersEnhanced, function (filter) {
                return _c(
                  "div",
                  { key: filter.title, staticClass: "products-filter__group" },
                  [
                    _c("h4", {
                      staticClass: "products-filter__group-title",
                      domProps: { innerHTML: _vm._s(filter.title) },
                    }),
                    _vm._v(" "),
                    _vm._l(filter.options, function (option) {
                      return _c(
                        "label",
                        {
                          key: option.id,
                          staticClass: "products-filter__option",
                        },
                        [
                          _c("input", {
                            staticClass: "products-filter__option-input",
                            attrs: { type: "checkbox" },
                            domProps: {
                              value: option.id,
                              checked: option.active,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.onChange(
                                  option,
                                  $event.target.checked
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "products-filter__option-label",
                            domProps: {
                              innerHTML: _vm._s(option.label || option.id),
                            },
                          }),
                        ]
                      )
                    }),
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _vm.filtersActive.length
                ? _c("Button", {
                    staticClass: "products-filter__reset",
                    attrs: {
                      text: _vm.$t("shoplist.filter.resetButton"),
                      type: "button",
                      level: "tertiary",
                      arrow: "",
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onResetFilters.apply(null, arguments)
                      },
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }